import { mapCollection } from '../../utils/collection.utils';
import { CamToolSlim } from '../cam-tool-slim';

export class CamToolSlimBuilder {
  static fromJson(json) {
    return (json)
      ? new CamToolSlim(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(CamToolSlimBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/cam-tool-slim.builder.ts